// extracted by mini-css-extract-plugin
export default {"blackBanner":"BlackBanner_blackBanner__XFaG7"};